export enum InventoryInformationCardType {
  every15minutes = "every15minutes",
  hourly = "hourly",
  daily = "daily",
  weekly = "weekly",
  monthly = "monthly",
  noRecentUpdates = "noRecentUpdates",
  notIntegratedDistributor = "notIntegratedDistributor",
}
